import { render, staticRenderFns } from "./ChartStart.vue?vue&type=template&id=44a227a8&scoped=true"
import script from "./ChartStart.vue?vue&type=script&lang=js"
export * from "./ChartStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a227a8",
  null
  
)

export default component.exports